import React, { useMemo } from "react"
import { Modal } from "react-bootstrap"
import CloseIcon from "@material-ui/icons/Close"
import { IconButton } from "@material-ui/core"
import { shallowEqual, useDispatch, useSelector } from "react-redux"
import * as actions from "../../../_redux/admin/inventory/InventoryActions"
import { ModalProgressBar } from "../../../../_partials/ModalProgressBar"
import { Button } from "../../../../_partials/Button"
import { useUIContext } from "../UIContext"
import "../Inventory.css"

const DeleteInventoryFirmwaresModal = ({
	showDeleteFirmware,
	setShowDeleteFirmware,
	technology,
	setSelectionModel
}) => {
	const dispatch = useDispatch()

	// ━━━━━━━━━━━━━  useUIContext  ━━━━━━━━━━━━━ \\
	const UIContext = useUIContext()
	const UIProps = useMemo(() => {
		return {
			ids: UIContext.idsInventoryFirmwares,
			setIds: UIContext.setIdsInventoryFirmwares
		}
	}, [UIContext])
	// ━━━━━━━━━━━━━  Selectors  ━━━━━━━━━━━━━ \\
	const { listLoading, user } = useSelector(
		state => ({
			listLoading: state.inventory.listLoading,
			user: state.auth.user
		}),

		shallowEqual
	)

	const [saving, setSaving] = React.useState(false)

	function onHide() {
		UIProps.setIds([])
		setSelectionModel([])
		setShowDeleteFirmware(false)
	}

	const deleteFirmwares = () => {
		if (!UIProps.ids || UIProps.ids.length <= 0 || !user || !user.id) {
			onHide()
			return
		}

		setSaving(true)

		dispatch(
			actions.deleteFirmwares({
				firmwareId: UIProps.ids,
				callersUserId: user.id,
				technology: technology,
				onHide
			})
		)
			.then(() => {
				setSaving(false)
				onHide()
			})
			.catch(error => {
				console.error("Error saving:", error) // Handle error
				setSaving(false) // Reset saving state on error
			})
	}

	return (
		<Modal
			show={showDeleteFirmware}
			backdrop="static"
			onHide={onHide}
			data-testid="DeleteInventoryFirmwaresModal"
		>
			<Modal.Header style={{ padding: "0.5rem 1rem 0 2rem", border: "none" }}>
				{/* ━━★  TITLE  ★━━ */}
				<div className="d-flex w-100 align-items-center justify-content-between">
					<div className="col-auto">
						<div className="row">
							<div
								className="d-flex justify-content-center align-items-end"
								style={{
									width: "16px",
									height: "16px",
									position: "relative",
									overflow: "hidden",
									backgroundColor: "#ffffff",
									outline: "2px solid #4A4A68",
									borderRadius: "50%",
									margin: "auto",
									marginRight: "10px"
								}}
							>
								<img
									style={{
										margin: "auto",
										width: "36%",
										height: "auto",
										display: "block"
									}}
									alt="areasInfo"
									src={"/media/crowdkeep/information_filled.svg"}
								/>
							</div>
							<div>
								<span className="custom-modal-title">Delete Firmwares</span>
							</div>
						</div>
					</div>
					<div className="col-auto">
						<IconButton
							onClick={onHide}
							disabled={saving}
							style={{ left: "12px" }}
							data-testid="close-button"
						>
							<CloseIcon />
						</IconButton>
					</div>
				</div>
			</Modal.Header>
			<Modal.Body
				style={{
					padding: "0",
					overflow: "hidden"
				}}
			>
				{listLoading && <ModalProgressBar variant="query" />}
				<div style={{ padding: "0 2rem 2rem 2rem" }}>
					{/* ━━★  BODY  ★━━ */}
					<div className="mb-4">
						{!listLoading && UIProps.ids && UIProps.ids.length > 0 && (
							<span className="custom-modal-body">
								You are currently deleting{" "}
								<span style={{ fontWeight: "bold" }}>{UIProps.ids.length}</span> Firmwares.
							</span>
						)}
						{listLoading && <span>Deleting nodes...</span>}
					</div>
					<div className="row justify-content-end mt-5">
						<div className="col-2" style={{ padding: "0", marginRight: "10px" }}>
							<Button
								variant="outlined"
								color="primary"
								style={{ width: "100%" }}
								disabled={listLoading || saving}
								onClick={onHide}
								text="Cancel"
								data-testid="cancel-button"
							/>
						</div>
						<div className="col-1" style={{ padding: "0", marginRight: "10px" }}>
							<Button
								id="inventory_unassign_btn"
								variant="contained"
								color="primary"
								style={{ width: "100%" }}
								disabled={listLoading}
								onClick={deleteFirmwares}
								text="Ok"
								data-testid="delete-button"
							/>
						</div>
					</div>
				</div>
			</Modal.Body>
		</Modal>
	)
}

export default DeleteInventoryFirmwaresModal
